module.exports = __webpack_public_path__ + "img/system40-mini.3aab303d.png";